var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-alert',{attrs:{"outlined":"","color":"color_primary","type":"info"}},[_vm._v(" "+_vm._s(_vm.$t("login.logout"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }